import { render, staticRenderFns } from "./quantityinput.vue?vue&type=template&id=00636638&"
import script from "./quantityinput.vue?vue&type=script&lang=js&"
export * from "./quantityinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sergey/projects/www/alfa-b2b/htdocs/local/templates/b2bportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('00636638', component.options)
    } else {
      api.reload('00636638', component.options)
    }
    module.hot.accept("./quantityinput.vue?vue&type=template&id=00636638&", function () {
      api.rerender('00636638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/catalog/quantityinput.vue"
export default component.exports